import { BrowserModule, Title } from '@angular/platform-browser';
import { APP_INITIALIZER, NgModule } from '@angular/core';
import { CommonModule, HashLocationStrategy, LocationStrategy } from '@angular/common';

import * as UserDetails from './pages/user-details';
import * as AfterApply from './pages/after-apply';
import * as QuoteCalculation from './pages/quote-calculation';
import * as medical from './pages/medical-underwriting';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import * as FormElements from './form-elements';
import * as CommonElements from './common-components';
import { UserDetailsRouteModule } from './pages/user-details/user-details-route.module';
import { QuoteCalculationRouteModule } from './pages/quote-calculation/quote-calculation-route.module'
import { MedicalUnderwritingRouteModule } from './pages/medical-underwriting/medical-underwriting-route.module';
import { CmsService } from './core/cms/service.service';
import { HealthService } from './core/cms/health/health.service';
import { CMSResolver } from './core/resolvers/cms.resolver';
import { HealthResolver } from './core/resolvers/healthAndLifestyle.resolver';
import { DatePipe } from '@angular/common';

import { StoreModule } from '@ngrx/store';
import { refReducer } from './store/reducers/reference-number.reducer';
import { persDetailsReducer } from './store/reducers/personal-details.reducer';
import { AuthLibService } from '@landg_eap/auth-lib';
import { AuthService } from 'src/app/shared/services/api-services/auth.service';
import { DcjConfigurationService } from './core/cms/dcj-configuration.service';
import { BeforeStartReducer } from './store/reducers/before-start.reducer';
import { depDetailsReducer } from './store/reducers/dependant-details.reducer';
import { YourPensionReducer } from './store/reducers/your-pension.reducer';
import { QuoteCaptureReducer } from './store/reducers/response-quote-datacapture.reducer';
import { QuoteCalculationReducer } from './store/reducers/response-quote-calculation.reducer';
import { ProductChoiceReducer } from './store/reducers/product-choice.reducer';
import { ReqQuoteCalculationReducer } from './store/reducers/request-quote-calculation.reducer';
import { QuoteResultReducer } from './store/reducers/quote-result.reducer';
import { LoggedinDetailReducer } from './store/reducers/loggedin-detail.reducer';
import { clearState } from './store/reducers/logout-reducer';
// import { QuoteEditComponent } from './quote-edit/quote-edit.component';
import { PageLoaderComponent } from './common-components/page-loader/page-loader.component';
import { QuotePlaybackRiskWarningReducer } from './store/reducers/playback-risk-warnings.reducer';
import { LifestyleReducer } from './pages/medical-underwriting/store/reducers/lifestyle.reducer';
import { MedicalConditionReducer } from './pages/medical-underwriting/store/reducers/medical-condition.reducer';
import { regsDetailsReducer } from 'src/app/store/reducers/registration-details.reducer';
import { TestUIModule } from './pages/test-ui-components/test.module';
import { InitialQuestionReducer } from './pages/medical-underwriting/store/reducers/initial-question.reducer';
import { ActivitiesOfDailyLivingReducer } from './pages/medical-underwriting/store/reducers/activities-of-daily-living.reducer';
import { SessionTimeoutService } from 'src/app/shared/services/api-services/session-timeout.service';
import { APIService } from './core/cms/api.service';
import { cardRefreshReducer } from 'src/app/store/reducers/card-refresh.reducers';
//import { QuestionaryResolver } from './core/resolvers/questionary.resolver';
import { AfterApplyRouteModule } from 'src/app/pages/after-apply/after-apply-route.module';
import { paymentDetailsReducer } from 'src/app/store/reducers/payment-details.reducer';
import { ClearToApplyReducer } from 'src/app/store/reducers/clear-to-apply.reducer';
import { healthRecordsReducer } from './store/reducers/health-records.reducer';
import { depHealthReducer } from './store/reducers/dep-health-records.reducer';
import { AddYourDependantDetails } from 'src/app/store/actions/your-dependant-details.actions';
import { YourDependantDetailsReducer } from 'src/app/store/reducers/your-dependant-detail.reducer';
import { YourPersonalDetailsReducer } from 'src/app/store/reducers/your-personal-details.reducer';
import { GuidanceAndAdviceReducer } from './store/reducers/guidance-and-advice.reducer';

import { BeneficiaryDetailsReducer } from 'src/app/store/reducers/beneficiary-details.reducer';
import { ResponseApplicationModalReducer } from 'src/app/store/reducers/response-applicationDataCapture.reducer';
import { YourProductApplicationReducer } from 'src/app/store/reducers/your-product-application.reducer';
import { pensionSavingsReducer } from './store/reducers/your-pension-savings.reducer';
import { UnderWritingDataReducer } from './pages/medical-underwriting/store/reducers/underwriting-ho.reducer';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { HttpErrorInterceptor } from './shared/services/api-services/http-config-interceptor.service';
import { UIRulesService } from 'src/app/shared';
import { uiCompJsonResolver } from 'src/app/shared/services/api-services/ui.comp.json.resolver';
import { configDataResolver } from 'src/app/shared/services/api-services/config-data.json.resolver';
import { YourLumpSumAllowancesReducer } from './store/reducers/your-lump-sum-allowances.reducer';
import { CredentialsInterceptor } from './shared/interceptor/credentials.interceptor';
import { ConfigLoaderService } from './shared/services/api-services/configLoader.service';

export function appInitializerFactory(
    configLoaderService: ConfigLoaderService
  ) {
    return () => configLoaderService.loadConfig();
  }
@NgModule({
    declarations: [
        AppComponent,
        PageLoaderComponent
    ],
    imports: [
        BrowserModule,
        CommonModule,
        StoreModule.forRoot({
            cardRefresh: cardRefreshReducer,
            refno: refReducer,
            personalDetails: persDetailsReducer,
            registrationDetails: regsDetailsReducer,
            beforeStart: BeforeStartReducer,
            dependantDetails: depDetailsReducer,
            yourpension: YourPensionReducer,
            quoteCapture: QuoteCaptureReducer,
            quoteCalculation: QuoteCalculationReducer,
            productChoice: ProductChoiceReducer,
            reqQuoteCalculation: ReqQuoteCalculationReducer,
            quoteResult: QuoteResultReducer,
            loggedinDetail: LoggedinDetailReducer,
            quotePlaybackRiskWarning: QuotePlaybackRiskWarningReducer,
            lifeStyle: LifestyleReducer,
            medicalCondtion: MedicalConditionReducer,
            initialQuestion: InitialQuestionReducer,
            activitiesOfDailyLiving: ActivitiesOfDailyLivingReducer,
            bankDetails: paymentDetailsReducer,
            clearApply: ClearToApplyReducer,
            yourPersonalDetails: YourPersonalDetailsReducer,
            beneficiaryDetails: BeneficiaryDetailsReducer,
            annuitantDoctorDetails: healthRecordsReducer,
            dependantDoctorDetails: depHealthReducer,
            yourDependantDetails: YourDependantDetailsReducer,
            applicationDataResponse: ResponseApplicationModalReducer,
            yourProductApplication: YourProductApplicationReducer,
            pensionSavings: pensionSavingsReducer,
            underwritingDataHO: UnderWritingDataReducer,
            guidanceAndAdvice: GuidanceAndAdviceReducer,
            yourLumpSumAllowances:YourLumpSumAllowancesReducer

        }, { metaReducers: [clearState] }),
        AppRoutingModule,
        UserDetailsRouteModule,
        QuoteCalculationRouteModule,
        FormElements.FormElementsModule,
        UserDetails.UserDetailsModule,
        QuoteCalculation.QuoteCalculationModule,
        CommonElements.CommonComponentsModule,
        MedicalUnderwritingRouteModule,
        medical.MedicalUnderwritingModule,
        TestUIModule,
        AfterApplyRouteModule,
        AfterApply.AfterApplyModule,
    ],
    providers: [CmsService, CMSResolver, HealthService, HealthResolver, SessionTimeoutService, APIService, UIRulesService,
        Title, uiCompJsonResolver, configDataResolver, DatePipe,
        {
          provide: HTTP_INTERCEPTORS,
          useClass: CredentialsInterceptor,
          multi: true,
        
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: HttpErrorInterceptor,
            multi: true
        },
        {
            provide: LocationStrategy,
            useClass: HashLocationStrategy
        },
        {
          provide: APP_INITIALIZER,
          useFactory: appInitializerFactory,
          deps: [ConfigLoaderService],
          multi: true,
        }],
    bootstrap: [AppComponent],
    
})
export class AppModule { }
